export const messages = {
  en: {
    cacheManage: {
      queryConditions: 'Query Conditions',
      enterCacheCode: 'Please enter cache code',
      enterCacheName: 'Please enter cache name',
      query: 'Query',
      reset: 'Reset',
      cacheInfo: 'Cache Information',
      cacheId: 'Cache ID',
      cacheCode: 'Cache Code',
      name: 'Name',
      operation: 'Operation',
      flushCache: 'Flush Cache',
      flushSuccess: 'Cache flushed successfully'
    }
  },
  zh: {
    cacheManage: {
      queryConditions: '查询条件',
      enterCacheCode: '请输入缓存编码',
      enterCacheName: '请输入缓存名称',
      query: '查询',
      reset: '重置',
      cacheInfo: '缓存信息',
      cacheId: '缓存ID',
      cacheCode: '缓存编码',
      name: '名称',
      operation: '操作',
      flushCache: '刷新缓存',
      flushSuccess: '刷新缓存成功'
    }
  }
}